/**
 * 대시보드 모듈 결함 drawer 기준 이전/다음 네비게이션 컨텍스트
 * @param {Array<{ seq?: number, id?: number, solarModuleSeq?: number, thermalImgSeq?: number }>} allDefects
 * @param {{ seq?: number, id?: number, solarModuleSeq?: number }} currentDefect
 * @param {number|string|null|undefined} moduleSeqFilter — drawer 모듈 필터(있으면 우선)
 */
export function buildModuleDefectNavContext(allDefects, currentDefect, moduleSeqFilter) {
  const moduleSeq =
    moduleSeqFilter != null && moduleSeqFilter !== ''
      ? moduleSeqFilter
      : currentDefect?.solarModuleSeq;

  if (moduleSeq == null || moduleSeq === '') {
    return { list: [], index: 0 };
  }

  const moduleKey = String(moduleSeq);
  const list = (Array.isArray(allDefects) ? allDefects : [])
    .filter(d => d && String(d.solarModuleSeq) === moduleKey)
    .map(d => ({
      seq: d.seq ?? d.id,
      solarModuleSeq: d.solarModuleSeq,
      thermalImgSeq: d.thermalImgSeq ?? d.thermal_img_seq
    }))
    .filter(d => d.seq != null)
    .sort((a, b) => Number(a.seq) - Number(b.seq));

  const currentId = currentDefect?.seq ?? currentDefect?.id;
  const index = list.findIndex(d => String(d.seq) === String(currentId));

  return {
    list,
    index: index >= 0 ? index : 0
  };
}
